import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'

export default {
  name      : 'MarketplaceAccountConnected',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : [],
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
